import { Checkbox } from "@mui/material";
import { ButtonTextTypography, CustomButtonWithCheckboxRoot } from "./CustomButtonWithCheckbox.styles";
import { FC } from "react";
import { ICustomButtonWithCheckbox } from "./CustomButtonWithCheckbox.props";

const CustomButtonWithCheckbox: FC<ICustomButtonWithCheckbox> = ({ disabled, onClick, title, isActive, buttonText }) => {
	return (
		<CustomButtonWithCheckboxRoot
			variant={"outlined"}
			disabled={disabled}
			size="medium"
			onClick={onClick}
			title={title}
			sx={{
				color: isActive ? "#1976d2" : "#9e9e9e",
				borderColor: isActive ? "#1976d2" : "#bdbdbd",
				"&:hover": {
					borderColor: isActive ? "#1976d2" : "#bdbdbd",
				},
			}}
		>
			<Checkbox
				checked={isActive}
				size="small"
				sx={{
					p: 0,
					mr: "6px",
					"& .MuiSvgIcon-root": {
						fontSize: 18,
						color: isActive ? "#1976d2" : "#9e9e9e",
					},
				}}
			/>
			<ButtonTextTypography component="span">{buttonText}</ButtonTextTypography>
		</CustomButtonWithCheckboxRoot>
	);
};

export default CustomButtonWithCheckbox;
